import { defaultGrid } from '../../helpers/datagrid';
import defaultReducer from './defaultReducer' ;

export default defaultReducer('COUNT_DETAILS_MODAL', { open: false, ...defaultGrid })
